export const dishLoad = (itemId) => {
    return axios
        .get(`/chain/api/dish/${itemId}`)
        .then((res) => res.data);
};

/** update */
export const dishUpdate = (dish, photo, archived) => {
    const categories = dish.categories.map(cat => cat.id)
    let formData = new FormData();
    formData.append('dish', JSON.stringify(dish));

    if (photo) {
        formData.append("photo", photo);
    }
    if (categories) {
        formData.append("categories", JSON.stringify(categories));
    }
    if (archived) {
        formData.append("archived", archived);
    }

    return axios
        .post(`/chain/api/dish/${dish.id}`, formData, {
            headers: { "content-type": "multipart/form-data" },
        })
        .then((res) => res.data);
};

export const modifierUpdate = (dish, photo, archived) => {
    let formData = new FormData();
    formData.append("dish", JSON.stringify(dish));

    if (photo) {
        formData.append("photo", photo);
    }
    if (archived) {
        formData.append("archived", archived);
    }

    return axios
        .post(`/chain/api/dish/${dish.id}`, formData, {
            headers: { "content-type": "multipart/form-data" },
        })
        .then((res) => res.data);
};

export const allergensUpdate = (dish) => {
    let formData = new FormData();
    let { allergens } = dish;
    let id = allergens.map((item) => item.id);
    for (let i = 0; i < id.length; i++) {
        formData.append("ids[]", id[i]);
    }

    return axios
        .post(`/chain/api/dish/${dish.id}/allergens`, formData, {
            headers: { "content-type": "multipart/form-data" },
        })
        .then((res) => res.data);
};

export const dishSave = (dish, photo) => {
    const categories = dish.categories.map(cat => cat.id)
    let formData = new FormData();
    formData.append("dish", JSON.stringify(dish));

    if (photo) {
        formData.append("photo", photo);
    }
    if (categories) {
        formData.append("categories", JSON.stringify(categories));
    }
    return axios
        .post(`/chain/api/dish-new`, formData, {
            headers: { "content-type": "multipart/form-data" },
        })
        .then((res) => res.data);
};

export const dishNewLoad = () => {
    return axios.get(`/chain/api/dish-new`).then((res) => res.data);
};

export const dishSettingsLoad = ({ slug }) => {
    return axios.get(`/chain/api/menu/${slug}/settings`).then((res) => res.data);
};

export const dishLanguages = ({ slug }) => {
    return axios.get(`/chain/api/dish/${slug}/translations`).then((res) => res.data);
};

export const dishLanguagesUpdate = ({ slug, params }) => {
    return axios.post(`/chain/api/dish/${slug}/translations`, params).then((res) => res.data);
};

export const allergensLoad = () => {
    return axios.get(`/chain/api/allergens`).then((res) => res.data);
};

export const createNewAllergen = (name) => {
    return axios.post(`/chain/api/allergens`, { name }).then((res) => res.data);
};

export const deleteAllergen = (id) => {
    return axios.delete(`/chain/api/allergens/${id}`).then((res) => res.data);
};
